import { useEffect, useState } from "react";
import { KeyRound } from "lucide-react";
import { adminApi } from "../../lib/api";

export const Joinings = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    const load = () => adminApi.get("/worker/joinings").then((r) => setItems(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { clearInterval(t); };
  }, []);
  if (!items.length) return null;
  return (
    <section data-testid="worker-joinings" className="space-y-3">
      <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-white"><KeyRound className="h-5 w-5 text-orange-400" />Joining</h2>
      {items.map((j) => (
        <div key={j.id} data-testid={`worker-joining-${j.id}`} className="flex flex-wrap items-center justify-between gap-4 border border-white/10 bg-[#0F172A] p-5">
          <div>
            <p className="font-semibold text-white">{j.company_name} · {j.job_role}</p>
            <p className="text-sm text-slate-400">
              {j.status === "active" ? `Joined on ${new Date(j.started_at).toLocaleDateString("en-IN")}`
                : j.otp ? `Show this code to the employer when you reach the site. Valid till ${new Date(j.otp_expires_at).toLocaleString("en-IN")}.`
                : "Code expired. Ask the employer to generate a new one."}
            </p>
          </div>
          {j.status === "pending" && j.otp && (
            <p data-testid={`worker-joining-otp-${j.id}`} className="bg-orange-500 px-5 py-3 font-mono text-3xl font-bold tracking-[0.4em] text-white">{j.otp}</p>
          )}
          {j.status === "active" && <span className="bg-emerald-500/15 px-3 py-1 text-sm font-semibold text-emerald-300">Hired</span>}
        </div>
      ))}
    </section>
  );
};
